import { CheckCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMarkdownTransformCompletedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface BlobTransformCompletedEventProps {
  event: DiscriminatedMarkdownTransformCompletedEvent;
}

export const BlobTransformCompletedEvent: React.FC<
  BlobTransformCompletedEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <CheckCircleIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="text-sm text-gray-600">
          Document transformed successfully
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Document Processing Complete"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
